import { render, staticRenderFns } from "./PageMessageGallery.vue?vue&type=template&id=89fd68c8&"
import script from "./PageMessageGallery.vue?vue&type=script&lang=ts&"
export * from "./PageMessageGallery.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports